export interface TopicSection {
  title: string;
  description: string;
  newsIds: string[];
}

export interface Topic {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  intro: string;
  reason: string;
  sections: TopicSection[];
  relatedTopicIds: string[];
}

export const topics: Topic[] = [
  {
    id: "topic-drama-2026",
    title: "2026 年度剧集观察",
    subtitle: "古装回潮、改编争议与配角出圈",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20courtyard%20at%20blue%20hour%20with%20hanging%20red%20lanterns%2C%20wet%20stone%20steps%2C%20warm%20amber%20practical%20lights%20against%20deep%20maroon%20shadows%2C%20editorial%20film%20still%2C%20wide%20composition%2C%20rich%20atmosphere%2C%20no%20people&width=1200&height=700&seq=topic-drama-2026-cover&orientation=landscape",
    intro:
      "从《长风渡月》的口碑逆袭，到《雾港》的改编争议，这一年的剧集市场比预想中更有意思。大制作不再稳赢，配角的讨论度超过主角，编剧开始被观众记住名字。",
    reason:
      "我们把这个专题做成一份观察笔记：既有开机与收官的现场，也有排片、票房与营销策略的拆解。想快速了解今年剧集发生了什么，从这里读起就够了。",
    sections: [
      {
        title: "一、这一年的现象级剧集",
        description: "收视、口碑与讨论度三条线同时上扬的作品",
        newsIds: ["ent-001", "ent-003"],
      },
      {
        title: "二、改编的边界在哪里",
        description: "原著与剧集之间的取舍，创作者怎么说",
        newsIds: ["ent-004", "ent-007"],
      },
      {
        title: "三、市场的新规则",
        description: "票房、营销与配角的意外出圈",
        newsIds: ["ent-005", "ent-008"],
      },
    ],
    relatedTopicIds: ["topic-copyright-rules", "topic-celebrity-romance"],
  },
  {
    id: "topic-celebrity-romance",
    title: "明星恋情全记录",
    subtitle: "把已知的放在一起，把未知的留给时间",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20seen%20from%20above%2C%20warm%20blurred%20streetlights%20reflecting%20on%20wet%20asphalt%2C%20two%20umbrellas%20in%20the%20distance%2C%20cinematic%20editorial%20photography%2C%20deep%20maroon%20and%20amber%20tones%2C%20moody%20and%20quiet&width=1200&height=700&seq=topic-celebrity-romance-cover&orientation=landscape",
    intro:
      "关于明星恋情的信息，往往真假混杂。这个专题只收录已经公开的画面、当事人的回应，以及可以核实的时间线。我们不替任何人下结论。",
    reason:
      "与其被一条条碎片消息牵着走，不如按时间把它们读一遍。你会发现，很多看起来「实锤」的细节，其实只是巧合；而真正重要的回应，常常只有一句话。",
    sections: [
      {
        title: "一、被拍到的瞬间",
        description: "公开画面与网友描述，均已标注信源",
        newsIds: ["gos-001", "gos-002"],
      },
      {
        title: "二、一场取关引发的讨论",
        description: "细节被放大的时候，我们在讨论什么",
        newsIds: ["gos-003", "gos-005"],
      },
      {
        title: "三、片场与私下",
        description: "同框不等于故事，路透也需要上下文",
        newsIds: ["gos-006", "gos-004"],
      },
    ],
    relatedTopicIds: ["topic-drama-2026", "topic-concert-economy"],
  },
  {
    id: "topic-concert-economy",
    title: "演唱会经济热潮",
    subtitle: "票、舞台与三小时的临时取消",
    cover:
      "https://readdy.ai/api/search-image?query=Large%20outdoor%20concert%20crowd%20seen%20from%20behind%20at%20night%2C%20warm%20amber%20stage%20beams%20cutting%20through%20haze%2C%20thousands%20of%20phone%20lights%2C%20cinematic%20concert%20photography%2C%20crimson%20and%20gold%20palette%2C%20film%20grain&width=1200&height=700&seq=topic-concert-economy-cover&orientation=landscape",
    intro:
      "演出市场在两年内迅速回暖，随之而来的是一连串新问题：票务规则、退改签、临时取消、黄牛与技术故障。热潮之下，秩序还在追赶。",
    reason:
      "如果你今年看过演出，或者正准备买票，这个专题里的三篇报道值得读完。它们讲的不是热闹，而是热闹背后的成本由谁承担。",
    sections: [
      {
        title: "一、买票这件事",
        description: "规则、平台与消费者的位置",
        newsIds: ["soc-001", "soc-005"],
      },
      {
        title: "二、舞台之外",
        description: "现场的人与他们的工作",
        newsIds: ["ent-002", "soc-004"],
      },
    ],
    relatedTopicIds: ["topic-copyright-rules", "topic-drama-2026"],
  },
  {
    id: "topic-copyright-rules",
    title: "娱乐圈的版权与规则",
    subtitle: "当内容开始被认真计价",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20film%20reels%20and%20legal%20documents%20stacked%20on%20a%20dark%20wooden%20desk%2C%20single%20warm%20lamp%20casting%20amber%20light%2C%20deep%20maroon%20background%2C%20moody%20editorial%20still%20life%2C%20fine%20dust%2C%20no%20people&width=1200&height=700&seq=topic-copyright-rules-cover&orientation=landscape",
    intro:
      "搬运、二创、集资、应援，这些曾经模糊的地带正在被重新划线。规则一旦明确，很多过去习以为常的做法就不再成立。",
    reason:
      "这不是一份法律意见，而是一组现场记录：判决怎么认定，平台怎么执行，从业者怎么应对。看完你会更清楚，边界大概在哪里。",
    sections: [
      {
        title: "一、版权这条线",
        description: "从搬运到二创，认定标准在变化",
        newsIds: ["soc-002", "ent-005"],
      },
      {
        title: "二、钱与规则",
        description: "集资、票务与行业自律",
        newsIds: ["soc-003", "soc-001"],
      },
      {
        title: "三、镜头前的人",
        description: "代拍、群演，以及他们的生计",
        newsIds: ["soc-006", "soc-004"],
      },
    ],
    relatedTopicIds: ["topic-concert-economy", "topic-drama-2026"],
  },
];